import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";

async function create(data: any): Promise<CommonRequest<any>> {
  const response = await http
    .postData("/asesmen-awal-ranap-kebidanan", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function update(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-awal-ranap-kebidanan/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-ranap-kebidanan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/asesmen-awal-ranap-kebidanan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http
    .deleteData(`/asesmen-awal-ranap-kebidanan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signBidan(
  id: number,
  data: any
): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-awal-ranap-kebidanan/${id}/sign-bidan`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signDpjp(
  id: number,
  data: any
): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-awal-ranap-kebidanan/${id}/sign-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signBpja(
  id: number,
  data: any
): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-awal-ranap-kebidanan/${id}/sign-bpja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/asesmen-awal-ranap-kebidanan/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  signBidan,
  signDpjp,
  signBpja,
  printPdf
};
